import ClearIcon from "@mui/icons-material/Clear";
import { ClickAwayListener } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import type { FunctionComponent } from "react";
import { useState } from "react";
import { Calendar } from "react-date-range";
import type { ControllerRenderProps, FieldErrors } from "react-hook-form";

import { FormLabel, StyledTextField } from "scmp-app/components/posties/student-form/styles";
import { formatInTimeZone } from "scmp-app/lib/utils";

import { CalendarContainer, Container } from "./styles";

type Props = {
  errors: FieldErrors;
  field: ControllerRenderProps;
  label: string;
  name: string;
};

export const FieldDatePicker: FunctionComponent<Props> = ({ errors, field, label, name }) => {
  const [showDate, setShowDate] = useState(false);
  const dateFormat = "yyyy-MM-dd";
  const value = field.value ? formatInTimeZone(field?.value as Date, dateFormat) : "";

  return (
    <>
      <FormLabel>{label}</FormLabel>
      <ClickAwayListener onClickAway={() => setShowDate(false)}>
        <Container>
          <StyledTextField
            {...field}
            error={!!errors[name]}
            fullWidth
            helperText={String(errors[name]?.message ?? "")}
            onChange={() => {}}
            onClick={() => setShowDate(true)}
            placeholder="YYYY-MM-DD"
            slotProps={{
              input: {
                endAdornment: field.value !== null && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        field.onChange(null);
                      }}
                      sx={{ p: 0 }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
            value={value}
            variant="outlined"
          />
          {showDate && (
            <CalendarContainer>
              <Calendar
                date={new Date()}
                disabledDay={date => date >= new Date()}
                onChange={item => {
                  field.onChange(formatInTimeZone(item, dateFormat));
                  setShowDate(false);
                }}
              />
            </CalendarContainer>
          )}
        </Container>
      </ClickAwayListener>
    </>
  );
};

FieldDatePicker.displayName = "FieldDatePicker";
